export default __webpack_public_path__ + "static/B0200-f670680e1bd263f29346f2ebc87c99f2.png";